/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MessageItemsModule */

import { WafMatchElementSubParser } from 'object-types';
import { IWafMatchElementSubParser } from 'generated-types';
import { MessageItem } from 'ajs/modules/data-model/factories';
import { Component, Type } from '@angular/core';
import { TWindowElement } from 'ajs/modules/data-model/data-model.types';
import { withFullModalMixin } from 'ajs/js/utilities/mixins/with-full-modal.mixin';

/**
 * @description WafMatchElementSubParser Config Item
 * @author alextsg
 */
export class WafMatchElementSubParserConfigItem extends withFullModalMixin(MessageItem)<IWafMatchElementSubParser> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: WafMatchElementSubParser,
            windowElement: 'lazy-load',
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Method used to get Modal for lazy loaded component.
     */
    public async getModalComponent(windowElement: TWindowElement): Promise<Type<Component>> {
        const {
            WafMatchElementSubParserModalComponent,
        } = await import(
            /* webpackChunkName: "waf-profile-modal" */ /* eslint-disable-next-line max-len */
            'ng/lazy-loaded-components/modals/waf-profile-modal/waf-match-element-sub-parser-modal/waf-match-element-sub-parser-modal.component'
        );

        return WafMatchElementSubParserModalComponent as Type<Component>;
    }
}
